module.exports = __webpack_public_path__ + "static/accurkardia_bg-173b176340a9b10db30bc6360ce98fe4.png";